// // components/ReviewCard.jsx
// import { Box, Typography, IconButton } from "@mui/material";
// import DeleteIcon from "@mui/icons-material/Delete";
// import { Rating } from '@mui/material';
// import WomanIcon from '@mui/icons-material/Woman';
// import ManIcon from '@mui/icons-material/Man';
// import PersonIcon from '@mui/icons-material/Person';

// export function ReviewCard({ review, isAdmin = false, onDelete, programm_id }) {
//   const handleDelete = () => {
//     if (window.confirm("Удалить этот отзыв?")) {
//       if (onDelete) {
//         onDelete(review.id, programm_id);
//       }
//     }
//   };

//   // Иконка пола
//   const GenderIcon = () => {
//     if (!review.gender) return <PersonIcon sx={iconStyle} />;
//     return review.gender === "female"
//       ? <WomanIcon sx={{ ...iconStyle, color: "secondary.main" }} />
//       : <ManIcon sx={{ ...iconStyle, color: "primary.main" }} />;
//   };

//   // Стили иконки
//   const iconStyle = {
//     width: 56,
//     height: 56,
//     mr: 2,
//     backgroundColor: "rgba(0,0,0,0.04)",
//     borderRadius: "50%",
//     p: 1
//   };

//   return (
//     <Box
//       sx={{
//         position: "relative",
//         minWidth: 300,
//         maxWidth: 400,
//         maxHeight: 400, // ограничение высоты
//         p: 3,
//         m: 1,
//         borderRadius: 2,
//         boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//         backgroundColor: "background.paper",
//         display: "flex",
//         flexDirection: "column",
//         overflow: "hidden"
//       }}
//     >
//       {/* Кнопка удаления */}
//       {isAdmin && (
//         <IconButton
//           onClick={handleDelete}
//           sx={{
//             position: "absolute",
//             top: 8,
//             right: 8,
//             color: "error.main",
//             "&:hover": { bgcolor: "error.light", color: "white" }
//           }}
//         >
//           <DeleteIcon />
//         </IconButton>
//       )}

//       {/* Автор и пол */}
//       {(review.author || review.gender) && (
//         <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
//           <GenderIcon />
//           <Box>
//             {review.author && (
//               <Typography variant="h6" fontWeight="bold">{review.author}</Typography>
//             )}
//             {review.date && (
//               <Typography variant="body2" color="text.secondary">{review.date}</Typography>
//             )}
//           </Box>
//         </Box>
//       )}

//       {/* Текст и рейтинг в отдельном прокручиваемом блоке */}
//       <Box sx={{ flexGrow: 1, overflowY: "auto", pr: 1 }}>
//         {review.text && (
//           <Typography variant="body1" sx={{ mb: review.rating ? 1 : 0 }}>
//             "{review.text}"
//           </Typography>
//         )}
//         {review.rating && (
//           <Rating
//             name="read-only"
//             value={review.rating}
//             readOnly
//             precision={0.5}
//             max={5}
//             sx={{ color: "gold", alignSelf: "flex-start", mt: 0.5 }}
//           />
//         )}
//       </Box>
//     </Box>
//   );
// }


// // В ReviewCard.jsx - основные места для регулировки шрифтов:

// // 1. Название программы (строка ~75)
// fontSize: '0.9rem',  // можно увеличить до '1rem' или '1.1rem'

// // 2. Тип программы (строка ~82)
// fontSize: '0.7rem',  // можно увеличить до '0.75rem' или '0.8rem'

// // 3. Текст отзыва (строка ~111)
// fontSize: '0.95rem', // можно увеличить до '1rem' или '1.05rem'

// // 4. Имя автора (строка ~148)
// fontSize: '0.9rem',  // можно увеличить до '1rem'

// // 5. Дата (строка ~152)
// fontSize: '0.75rem', // можно увеличить до '0.8rem'

// // 6. Размер аватара (строка ~138-140)
// width: 40, height: 40, // можно увеличить до 44 или 48

// components/ReviewCard.jsx
// components/ReviewCard.jsx
// components/ReviewCard.jsx
// components/ReviewCard.jsx
import { Box, Typography, Paper, Avatar, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { Rating } from '@mui/material';
import WomanIcon from '@mui/icons-material/Woman';
import ManIcon from '@mui/icons-material/Man';
import PersonIcon from '@mui/icons-material/Person';
import SchoolIcon from '@mui/icons-material/School';

export function ReviewCard({ review, isAdmin = false, onDelete, programm_id, showProgramInfo = false }) {
  const handleDelete = () => {
    if (window.confirm("Удалить этот отзыв?")) {
      if (onDelete) {
        onDelete(review.id, programm_id);
      }
    }
  };

  // Защита от undefined
  if (!review) {
    return (
      <Paper sx={{ p: 2.5, height: 380, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Typography color="text.secondary">Отзыв временно недоступен</Typography>
      </Paper>
    );
  }

  // Безопасное получение данных
  const programTitle = review.programTitle || review.program?.titleProgram || "Образовательная программа";
  const programType = review.programType || review.program?.typesProgram?.[0] || "Общее направление";
  const author = review.author || 'Аноним';
  const text = review.text || '';
  const rating = review.rating || 0;
  const gender = review.gender || 'other';
  
  // Исправленная обработка даты
  const getValidDate = () => {
    const dateValue = review.dateNewsFormat || review.date || review.originalDate;
    if (!dateValue) return null;
    
    if (typeof dateValue === 'string') {
      const parsed = new Date(dateValue);
      return isNaN(parsed.getTime()) ? null : parsed;
    }
    if (dateValue instanceof Date) {
      return isNaN(dateValue.getTime()) ? null : dateValue;
    }
    return null;
  };
  
  const validDate = getValidDate();

  const getAvatarColor = () => {
    if (gender === 'female') return '#e91e63';
    if (gender === 'male') return '#2196f3';
    return '#9e9e9e';
  };

  const getAvatarIcon = () => {
    if (gender === 'female') return <WomanIcon />;
    if (gender === 'male') return <ManIcon />;
    return <PersonIcon />;
  };

  const formatDate = (dateValue) => {
    if (!dateValue) return '';
    try {
      return dateValue.toLocaleDateString('ru-RU', { 
        day: 'numeric', 
        month: 'long', 
        year: 'numeric' 
      });
    } catch {
      return '';
    }
  };

  return (
    <Paper
      elevation={3}
      sx={{
        position: "relative",
        p: 2.5,
        height: 220, // 👈 ФИКСИРОВАННАЯ ВЫСОТА 380px
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 3,
        transition: 'transform 0.2s, box-shadow 0.2s',
        backgroundColor: "background.paper",
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: '0 8px 20px rgba(0,0,0,0.12)'
        },
      }}
    >
      {/* Кнопка удаления для админа */}
      {isAdmin && (
        <IconButton
          onClick={handleDelete}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            zIndex: 2,
            color: "error.main",
            backgroundColor: "rgba(255,255,255,0.8)",
            '&:hover': { bgcolor: "error.light", color: "white" },
            width: 32,
            height: 32,
          }}
        >
          <DeleteIcon fontSize="small" />
        </IconButton>
      )}

      {/* Название программы - показываем только если нужно */}
      {showProgramInfo && (
        <Box 
          sx={{ 
            mb: 1.5,
            pb: 1,
            borderBottom: '2px solid',
            borderColor: 'primary.light',
            flexShrink: 0,
            pr: 4,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
            <SchoolIcon color="primary" sx={{ fontSize: 16 }} />
            <Typography 
              variant="caption" 
              color="primary.main" 
              fontWeight="bold"
              sx={{ textTransform: 'uppercase', letterSpacing: 0.5 }}
            >
              Программа
            </Typography>
          </Box>
          <Typography 
            variant="subtitle2"
            fontWeight="bold" 
            sx={{ 
              lineHeight: 1.3,
              fontSize: '0.9rem',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
          >
            {programTitle}
          </Typography>
          {programType && programType !== "Общее направление" && (
            <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem' }}>
              {programType}
            </Typography>
          )}
        </Box>
      )}

      {/* Текст отзыва - со скроллом для длинных */}
      <Box 
        sx={{ 
          flexGrow: 1,
          mb: 1.5,
          overflowY: 'auto', // 👈 ВСЕГДА СКРОЛЛ ДЛЯ ДЛИННЫХ
          pr: 0.5,
          '&::-webkit-scrollbar': {
            width: '4px',
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: '#f1f1f1',
            borderRadius: '4px',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#c1c1c1',
            borderRadius: '4px',
          },
        }}
      >
        <Typography 
          variant="body1" 
          sx={{ 
            fontStyle: 'italic',
            lineHeight: 1.5,
            fontSize: '0.95rem',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
          }}
        >
          {text ? `"${text}"` : 'Текст отзыва временно недоступен'}
        </Typography>
      </Box>

      {/* Рейтинг */}
      {rating > 0 && (
        <Box sx={{ mb: 1.5, flexShrink: 0 }}>
          <Rating
            value={rating}
            readOnly
            precision={0.5}
            size="medium"
            sx={{ color: '#ffb400' }}
          />
        </Box>
      )}

      {/* Автор */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          pt: 1,
          borderTop: '1px solid',
          borderColor: 'divider',
          flexShrink: 0,
        }}
      >
        <Avatar 
          sx={{ 
            width: 40,
            height: 40,
            backgroundColor: getAvatarColor(),
            mr: 1.5
          }}
        >
          {getAvatarIcon()}
        </Avatar>
        <Box>
          <Typography variant="subtitle1" fontWeight="bold" fontSize="0.9rem">
            {author}
          </Typography>
          {validDate && (
            <Typography variant="caption" color="text.secondary" fontSize="0.75rem">
              {formatDate(validDate)}
            </Typography>
          )}
        </Box>
      </Box>
    </Paper>
  );
}